<template>
    <div class="app has-header">
        <div class="header main">

            <div class="align-left">
                <dateselectionheader :label="monthDisplay" @PrevDate="PreviousDate" @NextDate="NextDate" @CalendarOpen="toggleDatePicker" @SetToday="SetDateToCurrentDay" />
            </div>

            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">

            </div>

        </div>
        <div class ="tablecontainer scrollbar-container" v-if="!loading">
            <datatable :state="bonusPaymentSettingsTableState"/>
        </div>


        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>

        </div>
    </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'bonuspaymentsettings',
  data () {
    return {
        loading: false,
        timeFrameStart: this.$helpers.getMomentTZ().hours(0).minutes(0),
        currentYear: this.$helpers.getCurrentMonthMomentTZ().year(),
        currentMonth: this.$helpers.getCurrentMonthMomentTZ().month(),
        currentDate: 1,
     }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        this.refresh();
    }
  },
  computed: {
    ...mapGetters(['storeId', 'rosterFromTo', 'bonusPaymentSettingsMap', 'collectiveContractMap', 'spotMap', 'storeSettings', 'uiDataMap', 'locationMap']),
    monthDisplay() {
        if (this.timeFrameStart != null) {
            return this.timeFrameStart.format('MMM YYYY');
        } else {
            return '-';
        }
    },
    contractTypes() {
        let types = [];
        this.uiDataMap.contractTypes.forEach(item => types.push({label: item.label_de, value: item.id}));
        return types;
    },

    employeeCategories() {
        let types = [];
        this.uiDataMap.employeeCategories.forEach(item => types.push({label: item.label_de, value: item.id}));
        return types;
    },
    employeeLevels() {
        let types = [];
        this.uiDataMap.employeeLevels.forEach(item => types.push({label: item.label_de, value: item.id}));
        return types;
    },
    employmentTypes() {
        let types = [];
        this.uiDataMap.employmentTypes.forEach(item => types.push({label: item.label_de, value: item.id}));
        return types;
    },

    bonusPaymentSettingsTableState(){
        let view = this;
        let state = {};
        const map = this.bonusPaymentSettingsMap;
        state = this.$helpers.GetDataTableStateFromObject({name: '', exclusiveGroup: '', from: '', to: '', bonusFrom: '', bonusTo: '', bonusShift: '', bonusHour: ''}, Object.values(map));
        state.headerMap['name'].sort = true;
        state.headerMap['name'].align = 'center';
        state.headerMap['name'].label = this.$t('pages.employeeData.name');
        state.headerMap['name'].DisplayLabel = (i) => {return i.name};

        state.headerMap['exclusiveGroup'].sort = true;
        state.headerMap['exclusiveGroup'].align = 'center';
        state.headerMap['exclusiveGroup'].label = this.$t('workBalance.bonus.groupPriority');
        state.headerMap['exclusiveGroup'].DisplayLabel = (i) => {return i.exclusiveGroup ? i.exclusiveGroup+' - '+i.priority : '-'};

        state.headerMap['from'].sort = true;
        state.headerMap['from'].align = 'center';
        state.headerMap['from'].label = this.$t('workBalance.bonus.validFrom');
        state.headerMap['from'].DisplayLabel = (i) => {return i.from ? view.$helpers.getMomentFromStringTZ(i.from).format("DD.MM.YYYY") : '-'};

        state.headerMap['to'].sort = true;
        state.headerMap['to'].align = 'center';
        state.headerMap['to'].label = this.$t('pages.employeeContract.validUntil');
        state.headerMap['to'].DisplayLabel = (i) => {return i.to ? view.$helpers.getMomentFromStringTZ(i.to).add(-1, 'days').format("DD.MM.YYYY") : '-'};

        state.headerMap['bonusFrom'].sort = true;
        state.headerMap['bonusFrom'].align = 'center';
        state.headerMap['bonusFrom'].label = this.$t('workBalance.bonus.from');
        state.headerMap['bonusFrom'].DisplayLabel = (i) => {return i.bonusFrom};

        state.headerMap['bonusTo'].sort = true;
        state.headerMap['bonusTo'].align = 'center';
        state.headerMap['bonusTo'].label = this.$t('workBalance.bonus.till');
        state.headerMap['bonusTo'].DisplayLabel = (i) => {return i.bonusTo};

        state.headerMap['bonusShift'].sort = true;
        state.headerMap['bonusShift'].align = 'center';
        state.headerMap['bonusShift'].label = this.$t('workBalance.bonus.lumpSum');
        state.headerMap['bonusShift'].DisplayLabel = (i) => {return (i.bonusShift/100.0).toFixed(2)};

        state.headerMap['bonusHour'].sort = true;
        state.headerMap['bonusHour'].align = 'center';
        state.headerMap['bonusHour'].label = this.$t('workBalance.bonus.perHour');
        state.headerMap['bonusHour'].DisplayLabel = (i) => {return i.useHourlyWage ? (i.hourlyWagePercentage+"% des Stundenlohns") : (i.bonusHour/100.0).toFixed(2)};


        state.headerMap['actions'] = {align: 'center',
            buttons:[
                {icon: 'fas fa-edit', action: ($event, data) => view.EditBonusPaymentSetting($event, data)},
                {icon: 'fas fa-trash', action: ($event, data) => view.DeleteBonusPaymentSetting($event, data)},
            ]
        };
        state.headerMap['actions'].width = '100px';
        return state;
    },
    headerButtons(){

        let view = this;

        let state= {
            buttons: []
        };
        //BUTTON 1




        state.buttons.push({
            type: "block",
            icon: "fa-sync-alt",
            click: () => {
                    view.refresh(true);
            },
            tooltip: this.$t('global.general.refreshData')
        });
        state.buttons.push({
                type: "block green",
                icon: "fa-plus",
                click: ($event) => {view.AddBonusPaymentSetting($event)},
                tooltip: this.$t('workBalance.bonus.addSetting'),
                helperText: this.$t('workBalance.bonus.addSettingHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/2519891985"
        });

        state.helperLinks = [
            {
                title:  this.$t('store.structure.getSupport'),
                helperText:  this.$t('store.structure.getSupportHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/16",
                externalLabel:  this.$t('store.structure.getSupportLabel'),
                cancelLabel: this.$t('global.ui.close'),
            }
        ];
        return state;
    },
  },
  watch: {
    rosterFromTo(newVal, oldVal) {
        if (newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined) {
            console.log("CALLING REFRESH FROM ROSTERFROMTO")
            this.refresh();
        }
    },
    storeId: function(val, oldVal) {
      this.refresh();
    },
  },
  // methods that implement data logic.
  methods: {
    setDateSelection(date) {
        let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
        this.dateSelectionStart = fixedDate;

        this.currentDate = fixedDate.date();
        this.currentMonth = fixedDate.month();
        this.currentYear = fixedDate.year();

        //update vuex store with calculated from to => triggers reload of data via refresh
        let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
        this.$store.commit('setRosterFromTo', {
            rosterFromTo: rosterFromTo
        });
        this.$forceUpdate();
    },
    PreviousDate() {
        let timeframe = 'month';
        let before = this.timeFrameStart.clone();

        this.timeFrameStart = this.timeFrameStart.add(-1, timeframe).clone();
        this.currentDate = this.timeFrameStart.date();
        this.currentMonth = this.timeFrameStart.month();
        this.currentYear = this.timeFrameStart.year();

        let rosterDate = this.timeFrameStart.clone().startOf('month');
        this.setDateSelection(rosterDate);

        this.$forceUpdate();
    },
    NextDate() {
        let timeframe = 'month';
        let before = this.timeFrameStart.clone();

        this.timeFrameStart = this.timeFrameStart.add(1, timeframe).clone();
        this.currentDate = this.timeFrameStart.date();
        this.currentMonth = this.timeFrameStart.month();
        this.currentYear = this.timeFrameStart.year();

        let rosterDate = this.timeFrameStart.clone().startOf('month');
        this.setDateSelection(rosterDate);

        this.$forceUpdate();
    },
    SetDateToCurrentDay() {
        this.timeFrameStart = this.$helpers.getMomentTZ().startOf('month');
        this.currentDate = this.timeFrameStart.date();
        this.currentMonth = this.timeFrameStart.month();
        this.currentYear = this.timeFrameStart.year();
        this.setDateSelection(this.timeFrameStart);
    },
    toggleDatePicker($event) {
        let view = this;
        let date = this.$helpers.getMomentTZ().date(this.currentDate).month(this.currentMonth).year(this.currentYear);
        this.$helpers.OpenDatepickerPopup(
            { viewsEnabled: ['M'], date: date },
            {
                OnDateSelect: (date) => { view.onDatePicked(date) },
            },
            { elRelative: $event ? $event.currentTarget : null });
    },
    onDatePicked(date) {
        let before = this.timeFrameStart.clone();
        this.timeFrameStart = date.clone();
        let rosterDate = this.timeFrameStart.clone().startOf('month');
        this.setDateSelection(rosterDate);
    },
    refresh(force = false){
        let view = this;
        view.loading = true;
        view.$helpers.GetUiDataMap()
        .then(response => {
            return view.$helpers.GetLocationMap()
        })
        .then(response => {
            return view.$helpers.GetCollectiveContractMap()
        }).then(response => {
            return view.$helpers.GetSpotMap()
        }).then(response => {
            return view.$helpers.GetBonusPaymentSettingsMap(force);
        }).then(response => {
           view.loading = false;
        }).catch(function (error) {
            console.log(error);
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
        })

    },
    AddBonusPaymentSetting($event){
        let view = this;


        let dataFillState = view.$helpers.GetBonusPaymentSettingState(null, this.uiDataMap,
                            Object.values(this.collectiveContractMap), Object.values(this.spotMap), Object.values(this.locationMap),
                            this.contractTypes, this.employeeCategories, this.employeeLevels, this.employmentTypes, this.storeSettings, false, null, (item)  => {
            if(!item.useMaxWorkTime){
                item.maxWorkTime = null;
            }
            if(!item.useExclusiveGroup){
                item.exclusiveGroup = null;
            }
            if(!item.useCheckTime){
                item.checkFrom = null;
                item.checkTo = null;
            }
            view.createBonusPaymentSetting(item);
        });

        view.$helpers.OpenPopup({
            elRelative: $event.currentTarget,
            type: 'datafill',
            componentState: dataFillState,
            header: this.$t('workBalance.payroll.addNewConfig'),
            width: "800px",
            expanded: true,
            centered: true
        });
    },
    createBonusPaymentSetting: function(item){
        let view = this;
        let url = '/api/sec/bonuspaymentsetting';

        let params = {
            storeId: this.$store.state.storeId,
        };

        let payload = {
            name: item.name,
            spotId: item.spotId,
            collectiveContractId: item.collectiveContractId,
            bonusHour: item.bonusHour,
            bonusShift: item.bonusShift,
            useHourlyWage: item.useHourlyWage,
            hourlyWagePercentage: item.hourlyWagePercentage,
            weekDays: item.weekDays,
            bonusMode: item.bonusMode,
            bonusCutoff: item.bonusCutoff,
            from: item.noValidFrom ? null : item.from.startOf('day').format(),
            to: item.noValidTo ? null : item.to.add(1, 'days').startOf('day').format(),
            bonusFrom: item.bonusFrom.format("HH:mm"),
            bonusTo: item.bonusTo.format("HH:mm"),
            contractTypes: item.contractTypes,
            employeeCategories: item.employeeCategories,
            employeeLevels: item.employeeLevels,
            minWorkTime: item.minWorkTime,
            maxWorkTime: item.maxWorkTime,
            exclusiveGroup: item.exclusiveGroup,
            priority: item.priority,
            onlyHoliday: item.onlyHoliday,
            holidayTypes: item.holidayTypes,
            applyToUnderage: item.applyToUnderage,
            conditionJoin: item.conditionJoin,
            shiftSpotId: item.shiftSpotId,
            fromLocationId: item.fromLocationId,
            equalizeMonthly: item.equalizeMonthly,
            employmentTypes: item.employmentTypes,
            ewbWorkTimePercentage: item.ewbWorkTimePercentage,
            startsWithin: item.startsWithin,
            checkFrom: item.checkFrom ? item.checkFrom.format("HH:mm") : null,
            checkTo: item.checkTo ? item.checkTo.format("HH:mm") : null,
        }

        if(Object.values(view.bonusPaymentSettingsMap).filter(i => i.name == payload.name).length > 0){
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.bonus.nameExists'));
        } else {
            this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$set(view.bonusPaymentSettingsMap, ''+response.data.data.id, response.data.data);
                view.$store.commit("invalidateState", {states: ["bonusPaymentSettingsMapState"]});
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('workBalance.payroll.addedNewConfig'));
            }).catch(function (error) {

                view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.accounting.addedError'));
            })
        }



    },


    EditBonusPaymentSetting($event, setting){
        let view = this;

        let dataFillState = view.$helpers.GetBonusPaymentSettingState(setting, this.uiDataMap,
        Object.values(this.collectiveContractMap), Object.values(this.spotMap), Object.values(this.locationMap),
        this.contractTypes, this.employeeCategories, this.employeeLevels,  this.employmentTypes, this.storeSettings, false, null, (item)  => {
            if(!item.useMaxWorkTime){
                item.maxWorkTime = null;
            }
            if(!item.useExclusiveGroup){
                item.exclusiveGroup = null;
            }
            if(!item.useCheckTime){
                item.checkFrom = null;
                item.checkTo = null;
            }
            view.updateBonusPaymentSetting(item);
        });
        view.$helpers.OpenPopup({
            elRelative: $event.currentTarget,
            type: 'datafill',
            componentState: dataFillState,
            header: this.$t('global.ui.editConfig'),
            width: "800px",
            expanded: true,
            centered: true
        });
    },
    updateBonusPaymentSetting(item) {
        let view = this;
        let url = '/api/sec/bonuspaymentsetting';

        let params = {
            storeId: this.$store.state.storeId,
        };

        let payload = {
            id: item.id,
            name: item.name,
            spotId: item.spotId,
            collectiveContractId: item.collectiveContractId,
            bonusHour: item.bonusHour,
            bonusShift: item.bonusShift,
            useHourlyWage: item.useHourlyWage,
            hourlyWagePercentage: item.hourlyWagePercentage,
            weekDays: item.weekDays,
            bonusMode: item.bonusMode,
            bonusCutoff: item.bonusCutoff,
            from: item.noValidFrom ? null : item.from.startOf('day').format(),
            to: item.noValidTo ? null : item.to.add(1, 'days').startOf('day').format(),
            bonusFrom: item.bonusFrom.format("HH:mm"),
            bonusTo: item.bonusTo.format("HH:mm"),
            contractTypes: item.contractTypes,
            employeeCategories: item.employeeCategories,
            employeeLevels: item.employeeLevels,
            applyToUnderage: item.applyToUnderage,
            minWorkTime: item.minWorkTime,
            maxWorkTime: item.maxWorkTime,
            exclusiveGroup: item.exclusiveGroup,
            priority: item.priority,
            onlyHoliday: item.onlyHoliday,
            holidayTypes: item.holidayTypes,
            conditionJoin: item.conditionJoin,
            shiftSpotId: item.shiftSpotId,
            fromLocationId: item.fromLocationId,
            equalizeMonthly: item.equalizeMonthly,
            employmentTypes: item.employmentTypes,
            ewbWorkTimePercentage: item.ewbWorkTimePercentage,
            startsWithin: item.startsWithin,
            checkFrom: item.checkFrom ? item.checkFrom.format("HH:mm") : null,
            checkTo: item.checkTo ? item.checkTo.format("HH:mm") : null,
            updateFields: ["employeeCategories", "employeeLevels", "name", "spotId", "collectiveContractId",
                           "bonusHour", "bonusShift", "useHourlyWage", "hourlyWagePercentage",
                           "weekDays", "bonusMode", "bonusCutoff", "from", "to", "bonusFrom", "bonusTo",
                           "contractTypes", "applyToUnderage", "conditionJoin", "minWorkTime", "maxWorkTime",
                           "exclusiveGroup", "onlyHoliday", "priority", "shiftSpotId", "fromLocationId",
                           "equalizeMonthly", "employmentTypes", "ewbWorkTimePercentage", "startsWithin", 
                           "holidayTypes", "checkFrom", "checkTo"]  
        }


        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            let copy = Object.assign({}, payload);
            delete copy.updateFields;
            view.$store.commit("setBonusPaymentSettingsMapEntry", copy);

            view.$helpers.success(view.$t('global.notifications.success'), view.$t('workBalance.payroll.editedConfig'));
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.payroll.editError'));
        })
    },
    DeleteBonusPaymentSetting($event, data){
        let view = this;

        view.$helpers.OpenAlert({header: this.$t('workBalance.payroll.deleteConfig'), description: this.$t('workBalance.accounting.settingDeletionQuery', [data.name]), callbackAccept: (alert) => {
            alert.hidden = true;
            view.deleteBonusPaymentSetting(data);
        }});
    },
    deleteBonusPaymentSetting: function(data){

        let view = this;
        let url = '/api/sec/bonuspaymentsetting';

        let params = {
          storeId: this.$store.state.storeId,
          id: data.id
        };


        this.axios({
            method: 'delete',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            view.$store.commit("deleteBonusPaymentSettingsMapEntry", {id: data.id});

            view.$helpers.success(view.$t('global.notifications.success'), view.$t('global.notifications.settingDeleted'));
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.deleteFailed'));
        })

    },


  },

}
</script>


<style scoped>
    .tablecontainer{
        padding-left: 30px;
        padding-right: 30px;
    }

    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        top: var(--header-height);
    }
    .header.top{
        margin: 10px 0;
    }
    .data-table{
        top: 10px;
        position: relative;
    }

    .loading{

        -webkit-filter: none !important;
        filter: none !important;
        position: absolute;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
        bottom: 0;
        left: 0;
        top: initial;
        width: 100%;
        height: calc(100vh - 109px);
        background: rgba(0,0,0,.5);
        z-index: 10;
        position: fixed;
    }

    .header > .header.date{
        width: fit-content;
    }

    .paging{
        top: 0;
        bottom: 0;
        right: 250px;
    }

    .header > .text-filter{
        top: 0;
        bottom: 0;
        width: 230px;
        right: 45px;
    }

</style>
